import { useQuery } from "@apollo/client";

import {
  LIST_OWN_USER_SCHEDULES_QUERY,
  LIST_OWN_CALENDAR_EVENTS_QUERY,
} from "~/api";
import { ITEMS_PER_PAGE } from "~/constants";

export const useListOwnUserSchedules = ({
  limit = ITEMS_PER_PAGE,
  skip = 0,
  where,
  sort = [],
  skipCondition = false,
}) => {
  const {
    data: { listOwnUserSchedules } = { listOwnUserSchedules: {} },
    loading,
    error,
    refetch,
    fetchMore,
  } = useQuery(LIST_OWN_USER_SCHEDULES_QUERY, {
    variables: {
      params: {
        limit,
        skip,
        sort,
        where,
      },
    },
    skip: skipCondition,
  });

  const {
    currentPage,
    limit: itemLimit,
    skip: itemSkip,
    totalCount,
    userSchedules = [],
  } = listOwnUserSchedules;

  const handleFetchMore = ({ limit, skip }) => {
    fetchMore({
      variables: {
        params: {
          limit,
          skip,
          sort,
          where,
        },
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult;
        }

        const mergedUserSchedules = [
          ...previousResult.listOwnUserSchedules.userSchedules,
          ...fetchMoreResult.listOwnUserSchedules.userSchedules,
        ];

        const updates = {
          ...previousResult,
          listOwnUserSchedules: {
            ...previousResult.listOwnUserSchedules,
            ...fetchMoreResult.listOwnUserSchedules,
            userSchedules: mergedUserSchedules,
          },
        };

        return updates;
      },
    });
  };

  return {
    currentPage,
    error,
    handleFetchMore,
    limit: itemLimit,
    loading,
    refetch,
    skip: itemSkip,
    totalCount,
    userSchedules,
  };
};

export const useListUsersCalendarEvents = ({
  endDate,
  skipCondition = false,
  startDate,
}) => {
  const {
    data: { listUsersCalendarEvents } = { listUsersCalendarEvents: [] },
    loading,
    error,
    refetch,
  } = useQuery(LIST_OWN_CALENDAR_EVENTS_QUERY, {
    variables: {
      startDate,
      endDate,
    },
    skip: skipCondition,
    fetchPolicy: "no-cache",
    nextFetchPolicy: "no-cache",
  });

  return {
    data: listUsersCalendarEvents,
    loading,
    error,
    refetch,
  };
};
